import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { delete_icon, edit_icon, user, user_img } from "../../../assets/imgs";
import moment from "moment";
import ToggleOffIcon from "@mui/icons-material/ToggleOff";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import StatusComp from "../../../components/StatusComp";
import CompanyGroupView from "../../../components/CompanyGroupView";
import { cameraData, group1, group2, group3 } from "../../redux/api/dummyJson";
import SelectBox from "../../../components/SelectBox";
import CompanySitesAdd from "../../../components/CompanySitesAdd";
import { get, post } from "../../../Services/ApiHandler";
import { URL } from "../../../Services/Constant";
import { toast } from "react-toastify";

const SiteUser = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [siteList, setSiteList] = useState([]);
  const [show, setShow] = useState(false);

  const [confirm, setConfirm] = useState(false);
  const groupNameRef = useRef(null);

  const formDataObj = {
    name: "",
    code: "",
    address: "",
    location: "",
    adminName: "",
    adminEmail: "",
    adminMobile: "",
    adminImage: "",
    sitelocation: "",
    sitename: "",
  };

  const [formData, setFormData] = useState(formDataObj);

  const fileInputRef = useRef(null);

  const [errors, setErrors] = useState({});
  const [siteErrors, setSiteErrors] = useState({});
  const [popup, setPopup] = useState(false);
  const [groupPopup, setGroupPopup] = useState(false);
  const [selectedCamera, setSelectedCamera] = useState(null);

  const type = location?.state?.type;
  const data = location?.state?.data;
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [siteID, setSiteID] = useState(
    user_details?.knf_company_site_id ? user_details?.knf_company_site_id : "",
  );

  const [locList, setLoclist] = useState([]);
  const [emailCheckDataGroup, setEmailCheckDataGroup] = useState({});

  const [emailVerified, setEmailVerified] = useState(false);

  const getLocationList = () => {
    get(URL.COMPANY_LOCATION)
      .then((res) => {
        if (res?.status == "success") {
          setLoclist(res?.data);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setSiteErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const createdAt = moment().format("DD-MM-YYYY");

  const validate = () => {
    const newErrors = {};

    if (formData?.name?.length == 0) newErrors.name = "Site Name is required";
    if (formData?.location?.length == 0)
      newErrors.location = "Site location is required";
    if (formData?.address?.length == 0)
      newErrors.address = "Site address is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validate()) {
      console.log("Submit successful", formData);
      // navigate("/company-sites");
    }
  };

  //site admin

  const siteValidate = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (!formData.adminName.trim())
      newErrors.adminName = "Site Admm Name is required";
    if (!formData.adminEmail.trim() || !emailRegex.test(formData.adminEmail))
      newErrors.adminEmail = "Valid Email is required";

    if (
      !formData.adminMobile.trim() ||
      !singaporeMobileRegex.test(formData.adminMobile)
    ) {
      newErrors.adminMobile = "Enter valid 8-digit Singapore number";
    }

    if (!formData.adminImage)
      newErrors.adminImage = "site admin image is required";
    setSiteErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSiteAdd = () => {
    if (
      siteValidate(
        formData.adminName,
        formData.adminEmail,
        formData.adminMobile,
        formData.adminImage,
      )
    ) {
      const newSite = {
        id: Date.now(),
        adminName: formData.adminName,
        adminEmail: formData.adminEmail,
        adminMobile: formData.adminMobile,
        adminImage: formData.adminImage,
        active: true,
        editing: false,
      };
      setSiteList((prev) => [...prev, newSite]);
      setFormData((prev) => ({
        ...prev,
        adminName: "",
        adminEmail: "",
        adminMobile: "",
      }));
      setShow(true);
    }
  };

  const handleSiteChange = (field, value) => {
    if (field == "adminImage") {
      let image = value.target.files[0];
      if (image) {
        setSiteList((prev) =>
          prev.map((site) => ({
            ...site,
            [field]: image,
          })),
        );
      }
    } else {
      setSiteList((prev) => prev.map((site) => ({ ...site, [field]: value })));
    }

    setSiteErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleGroupChange = (e) => {
    const { name, value } = e.target;
    if (name == "groupCategory" && value == 3) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 1, beep: 1 }));
    } else if (name == "groupCategory" && value == 4) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else if (name == "groupCategory" && value == 5) {
      setGroupForm((prev) => ({ ...prev, [name]: value, alert: 0, beep: 0 }));
    } else {
      setGroupForm((prev) => ({ ...prev, [name]: value }));
    }
    setGroupErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleEdit = (id) => {
    setSiteList((prev) =>
      prev.map((site) =>
        site.id === id ? { ...site, editing: !site.editing } : site,
      ),
    );
  };

  // console.log('siteList', siteList);

  const handleDelete = () => {
    const newSite = {
      id: Date.now(),
      adminName: formData.adminName,
      adminEmail: formData.adminEmail,
      adminMobile: formData.adminMobile,
      adminImage: formData.adminImage,
      active: true,
      editing: false,
    };
    setSiteList([newSite]);
    setFormData({
      adminName: "",
      adminEmail: "",
      adminMobile: "",
      adminImage: "",
    });
    setShow(true);
    setConfirm(false);
    setPopup(false);
  };

  //group users

  const groupFormObj = {
    groupName: "",
    groupEmail: "",
    groupMobile: "",
    groupCategory: "",
    groupImage: "",
    alert: 0,
    beep: 0,
  };

  const [groupUsers, setGroupUsers] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [groupForm, setGroupForm] = useState(groupFormObj);

  console.log("groupUsers", groupUsers);
  const [groupErrors, setGroupErrors] = useState({});

  const validateGroup = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const singaporeMobileRegex = /^[789]\d{7}$/;

    if (groupForm?.groupName?.length == 0)
      newErrors.groupName = "Group user name is required";
    if (
      groupForm.groupEmail?.length == 0 ||
      !emailRegex.test(groupForm.groupEmail)
    )
      newErrors.groupEmail = "Valid email is required";

    if (
      groupForm.groupMobile?.length == 0 ||
      !singaporeMobileRegex.test(groupForm.groupMobile)
    ) {
      newErrors.groupMobile = "Enter valid 8-digit Singapore number";
    }

    if (groupForm.groupCategory?.length == 0)
      newErrors.groupCategory = "Category is required";
    // if (!groupForm.groupImage) newErrors.groupImage = "user image is required";

    if (groupForm.groupCategory == 3) {
      if (!groupForm.alert) {
        newErrors.alert = "Alert Notifications should be enabled";
      }

      if (groupForm.beep && !groupForm.alert) {
        newErrors.beep =
          "Beep Sound cannot be enabled without enabling Alert Notifications";
      }
    }
    setGroupErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleResetGroup = () => {
    setGroupForm({
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 0,
    });

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    getGroupList();
  };

  const handleGroupAdd = () => {
    if (validateGroup()) {
      let formdata = new FormData();
      formdata.append("name", groupForm.groupName);
      formdata.append("phone", groupForm.groupMobile);
      formdata.append("email", groupForm.groupEmail);
      formdata.append("knf_type", 1);
      formdata.append("notification_alert", groupForm.alert);
      formdata.append("beep_sound", groupForm.beep);
      formdata.append("group_category", groupForm.groupCategory);
      formdata.append("site_id", siteID);

      if (groupForm.groupImage?.name) {
        formdata.append("profile_image", groupForm.groupImage);
      }

      if (groupForm?.id) {
        post(URL.GROUP_USER_UPDATE + groupForm?.id, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      } else {
        post(URL.GROUP_USER_ADD, formdata)
          .then((res) => {
            if (res?.status == "success") {
              handleResetGroup();
              toast.success(res?.message);
              setEmailVerified(false);
            }
          })
          .catch((err) => {
            console.log("err", err);
          });
      }
      // setGroupUsers((prev) => [...prev, newUser]);
    }
  };

  const toggleGroupActive = (id) => {
    setGroupUsers((prev) =>
      prev.map((user) =>
        user.id === id ? { ...user, active: !user.active } : user,
      ),
    );
    setGroupPopup(false);
  };

  const deleteGroupUser = (id) => {
    post(URL.GROUP_USER_DELETE + id, {})
      .then((res) => {
        if (res?.status == "success") {
          handleResetGroup();
          toast.success(res?.message);
          setGroupPopup(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleSiteImage = (event, name) => {
    let image = event.target.files[0];
    if (image) {
      setFormData((prev) => ({
        ...prev,
        [name]: image,
      }));

      setSiteErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleGroupImage = (event, name) => {
    let image = event.target.files[0];
    if (image) {
      setGroupForm((prev) => ({
        ...prev,
        [name]: image,
      }));

      setGroupErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const getGroupList = () => {
    post(URL.GROUP_USER_LIST, {})
      .then((res) => {
        let temp = [];
        res?.lists?.map((item, ind) => {
          let obj = {
            ...item,
          };
          if (item?.group_category == 3) {
            obj.group_category = 1;
          }
          if (item?.group_category == 4) {
            obj.group_category = 2;
          }
          if (item?.group_category == 5) {
            obj.group_category = 3;
          }
          temp.push(obj);
        });
        if (res?.lists?.length > 0) {
          setGroupUsers(res?.lists);
        } else {
          setGroupUsers([]);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const groupUserStatus = (id) => {
    get(URL.GROUP_USER_STATUS + id)
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          getGroupList();
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGroupEdit = (item) => {
    if (item) {
      setGroupForm({
        id: item?.id,
        groupName: item?.name,
        groupEmail: item?.email,
        groupMobile: item?.phone,
        groupCategory: item?.group_category,
        alert: item?.notification_alert,
        beep: item?.beep_sound,
        groupImage: item?.profile_image,
        email_check: 1,
        method: "edit",
      });

      setEmailVerified(true);

      // Also need to scroll to the top
      setTimeout(() => {
        if (groupNameRef.current) {
          // Scroll the element into view
          groupNameRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          groupNameRef.current.focus();
        }
      }, 100);
    }
  };

  const getView = (id) => {
    get(URL.SITE_VIEW + id)
      .then((res) => {
        let data = res?.data?.[0];
        let ob = {
          userName: "",
          code: "",
          email: "",
          mobile: "",
          role: "",
          adminId: "",
          password: "",
          confirmPassword: "",
          companyname: "",
          companycode: "",
          sitename: "",
          sitecode: "",
          sitelocation: "",
        };

        if (data?.site_name) {
          ob.sitename = data?.site_name;
        }

        if (data?.site_code) {
          ob.sitecode = data?.site_code;
        }

        if (data?.site_location) {
          ob.sitelocation = data?.site_location;
        }

        if (data?.site_address) {
          ob.address = data?.site_address;
        }

        if (data?.user_name) {
          ob.userName = data?.user_name;
        }

        if (data?.user_phone) {
          ob.mobile = data?.user_phone;
        }

        if (data?.user_email) {
          ob.email = data?.user_email;
        }

        if (data?.site_code) {
          ob.code = data?.site_code;
        }

        if (data?.profile_image) {
          // setLogo(data?.profile_image);
        }

        setFormData(ob);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getGropRole = () => {
    get(URL.GROUP_ROLE_LIST)
      .then((res) => {
        setGroupList(res?.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (siteID) {
      getView(siteID);
    }
    getLocationList();
    getGroupList();
    getGropRole();
  }, []);

  const autoFetchDataGroup = (data_new) => {
    let data = {
      ...data_new?.user,
      company: {
        ...data_new?.company,
        site: data_new?.site,
      },
    };
    setEmailCheckDataGroup(data);
    let ob = {
      groupName: "",
      groupEmail: "",
      groupMobile: "",
      groupCategory: "",
      groupImage: "",
      alert: 0,
      beep: 1,
      email_verified: data?.id ? 1 : 0,
    };
    if (data?.company?.site?.id) {
      setSiteID(data?.company?.site?.id);
    }

    if (data?.id) {
      ob.id = data?.id;
    }

    if (data?.email) {
      ob.groupEmail = data?.email;
      ob.groupEmail_verify = true;
      ob.method = "edit";
    }

    if (data?.name) {
      ob.groupName = data?.name;
    }
    if (data?.phone) {
      ob.groupMobile = data?.phone;
    }
    if (data?.profile_url) {
      ob.groupImage = data?.profile_url;
    }
    if (data?.knf_type) {
      ob.groupCategory = data?.knf_type;
    }

    if (data?.beep_sound) {
      ob.beep = data?.beep_sound;
    }

    if (data?.notification_alert) {
      ob.alert = data?.notification_alert;
    }

    setGroupForm(ob);
  };

  // const emailCheck = () => {
  //   let formdata = new FormData();
  //   if (groupForm.groupEmail?.length > 0) {
  //     formdata.append("email", groupForm.groupEmail);
  //     post("user/" + URL.EMAIL_CHECK, formdata)
  //       .then((res) => {
  //         let data = res?.userData?.[0];
  //         if (res?.userData?.length > 0) {
  //           if (data?.user?.knf_type >= 3 && data?.user?.knf_type <= 5) {
  //             autoFetchDataGroup(data);
  //           } else if (data?.user?.knf_type == null) {
  //             autoFetchDataGroup(data);
  //           } else {
  //             toast.error("Email ID already exists");
  //           }
  //         } else {
  //           let ob = {
  //             ...groupFormObj,
  //             id: groupForm.id,
  //             groupEmail: groupForm.groupEmail,
  //           };
  //           setGroupForm(ob);
  //           setEmailCheckDataGroup({});
  //           toast("please enter all required fields");
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("err", err);
  //       });
  //   } else {
  //     toast.error("Please Enter Valid Email");
  //   }
  // };

  const emailCheck = () => {
    let formdata = new FormData();

    if (groupForm.groupEmail?.length > 0) {
      formdata.append("email", groupForm.groupEmail);

      post("user/" + URL.EMAIL_CHECK, formdata)
        .then((res) => {
          let data = res?.userData?.[0];

          if (res?.userData?.length > 0) {
            // Check if this is edit mode and email matches current user
            const isEditModeWithSameEmail =
              groupForm?.id && data?.user?.email === groupForm.groupEmail;

            if (isEditModeWithSameEmail) {
              // Just verify email without refreshing data
              setEmailVerified(true);
              toast.success("Email verified");
              return;
            }

            // Handle new email or new user
            if (data?.user?.knf_type >= 3 && data?.user?.knf_type <= 5) {
              // Only auto-fetch if not in edit mode
              if (!groupForm?.id) {
                autoFetchDataGroup(data);
              } else {
                // In edit mode with different email, show warning
                toast.warning("This email belongs to another user");
                setEmailVerified(false);
                return;
              }
              setEmailVerified(true);
            } else if (data?.user?.knf_type == null) {
              if (!groupForm?.id) {
                autoFetchDataGroup(data);
              }
              setEmailVerified(true);
            } else {
              setEmailVerified(false);
              toast.error("Email ID already exists");
            }
          } else {
            // New email not in system
            if (!groupForm?.id) {
              let ob = {
                ...groupFormObj,
                id: groupForm.id,
                groupEmail: groupForm.groupEmail,
              };
              setGroupForm(ob);
            }
            setEmailCheckDataGroup({});
            setEmailVerified(true);
            toast.info("You can edit the details");
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      toast.error("Please Enter Valid Email");
    }
  };
  return (
    <div className="dashRightView">
      <StatusComp name={"Site"} type={type} />

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to{" "}
              {popup == "active" ? "deactivate" : "delete"} the site admin?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={() => setConfirm(true)} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {groupPopup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to delete the group user?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  deleteGroupUser(groupPopup);
                }}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setGroupPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {confirm && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              If you want to delete a site admin you need to add another one
            </p>
            <div className="m-3">
              <div className="col-md-9 mb-3">
                <input
                  className="input-box w-100"
                  name="adminName"
                  value={formData.adminName}
                  onChange={handleChange}
                  type="text"
                  placeholder="Site admin name"
                />
                {siteErrors.adminName && (
                  <p className="err">{siteErrors.adminName}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminEmail"
                  value={formData.adminEmail}
                  onChange={handleChange}
                  className="input-box w-100 "
                  type="email"
                  placeholder="Admin Email"
                />
                {siteErrors.adminEmail && (
                  <p className="err">{siteErrors.adminEmail}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminMobile"
                  value={formData.adminMobile}
                  onChange={handleChange}
                  className="input-box w-100 "
                  type="text"
                  placeholder="Mobile"
                />
                {siteErrors.adminMobile && (
                  <p className="err">{siteErrors.adminMobile}</p>
                )}
              </div>
              <div className="col-md-9 mb-3">
                <input
                  name="adminImage"
                  onChange={(e) => handleSiteImage(e, "adminImage")}
                  className="input-box w-100 "
                  type="file"
                  placeholder="Site Admin Image"
                  accept="image/*"
                />
                {siteErrors.adminImage && (
                  <p className="err">{siteErrors.adminImage}</p>
                )}
              </div>
            </div>
            <div className="d-flex ac-jb px-2 mt-5">
              <button onClick={handleDelete} className="add-btn w-40">
                Yes
              </button>
              <button
                onClick={() => {
                  setConfirm(false);
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 black">
        Group Users Section
      </p>

      {type !== "view" && (
        <>
          <div className="d-flex flex-row ac-js mt-5 gap-3">
            <div className="col-md-2 position-relative">
              <p className="f3 mb-1 primary d-flex">
                Email<span className="text-danger">*</span>
              </p>
              <input
                name="groupEmail"
                value={groupForm.groupEmail}
                onChange={(e) => {
                  handleGroupChange(e);
                  setEmailVerified(false);
                }}
                className="input-box w-100 "
                type="email"
                placeholder="Email"
                // disabled={groupForm?.id ? true : false}
              />
              {groupErrors.groupEmail && (
                <p className="err">{groupErrors.groupEmail}</p>
              )}
              {groupForm?.groupEmail?.length > 2 && (
                <p
                  className="position-absolute text-primary pointer end-0 fw-bold"
                  onClick={() => emailCheck()}
                >
                  Check
                </p>
              )}
            </div>
            <div className="col-md-2">
              <p className="f3 mb-1 primary d-flex">
                Group User name<span className="text-danger">*</span>
              </p>
              <input
                className={`input-box w-100 ${!emailVerified ? "opacity-50" : ""}`}
                ref={groupNameRef}
                name="groupName"
                value={groupForm.groupName}
                onChange={handleGroupChange}
                type="text"
                placeholder="Group user name"
                disabled={!emailVerified}
              />
              {groupErrors.groupName && (
                <p className="err">{groupErrors.groupName}</p>
              )}
            </div>

            <div className="col-md-2">
              <p className="f3 mb-1 primary d-flex">
                Singapore Mobile<span className="text-danger">*</span>
              </p>
              <input
                name="groupMobile"
                value={groupForm.groupMobile}
                maxLength={8}
                onChange={(e) => {
                  const val = e.target.value;

                  if (/^\d{0,8}$/.test(val)) {
                    handleGroupChange(e);
                  }
                }}
                className={`input-box w-100 ${!emailVerified ? "opacity-50" : ""}`}
                type="text"
                placeholder="+65 Mobile"
                disabled={!emailVerified}
              />
              {groupErrors.groupMobile && (
                <p className="err">{groupErrors.groupMobile}</p>
              )}
            </div>

            <div className="col-md-2">
              <p className="f3 primary d-flex" style={{ marginBottom: "-4%" }}>
                User Image
              </p>
              <span className="text-danger fs-12">
                JPG, JPEG, PNG only | Max size: 5MB
              </span>
              <input
                name="groupImage"
                onChange={(e) => handleGroupImage(e, "groupImage")}
                className={`input-box w-100 ${!emailVerified ? "opacity-50" : ""}`}
                type="file"
                accept="image/*"
                placeholder="User Image"
                disabled={!emailVerified}
                ref={fileInputRef}
                style={{
                  display: "none",
                }}
              />
              {/* {groupErrors.groupImage && (
                <p className="err">{groupErrors.groupImage}</p>
              )} */}
              <div className="col-md-3 d-flex ac-jb gap-3">
                <img
                  src={
                    groupForm.groupImage
                      ? typeof groupForm.groupImage === "string"
                        ? groupForm.groupImage
                        : window.URL.createObjectURL(groupForm.groupImage)
                      : user_img
                  }
                  alt="group Logo"
                  className={`user pointer ${!emailVerified ? "opacity-50" : ""}`}
                  style={{
                    borderRadius: "50px",
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                  onClick={() => fileInputRef.current?.click()}
                />

                <img
                  src={edit_icon}
                  alt="Edit"
                  className={`edit-btn pointer ${!emailVerified ? "opacity-50" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => fileInputRef.current?.click()}
                  disabled={!emailVerified ? true : false}
                />
              </div>
            </div>
            <div className="col-md-2">
              <p className="f3 mb-1 primary d-flex">
                Select Group<span className="text-danger">*</span>
              </p>

              <select
                name="groupCategory"
                onChange={handleGroupChange}
                value={groupForm.groupCategory}
                className={`input-box w-100 ${!emailVerified ? "opacity-50" : ""}`}
                // disabled={groupForm?.groupEmail_verify ? true : false}
                disabled={!emailVerified}
              >
                <option value={""}>Select</option>
                {groupList?.map((item, ind) => {
                  return (
                    <option value={item?.id} key={ind}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>

              {groupErrors.groupCategory && (
                <p className="err">{groupErrors.groupCategory}</p>
              )}
            </div>

            {emailVerified && (
              <div className="col-md-1 mt-4 ps-2">
                <button
                  onClick={handleGroupAdd}
                  className="medium-btn ms-4 d-flex align-items-center justify-content-center gap-2"
                >
                  {/* <CheckCircleIcon fontSize="small" /> */}
                  Add
                </button>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-center gap-5 me-5 mt-3">
            {groupForm.groupCategory == "group1" && (
              <div className="d-flex flex-column flex-start">
                <label className="form-label">Select Group User</label>
                <SelectBox
                  arrayData={cameraData}
                  selectedOption={selectedCamera}
                  setSelectedOption={setSelectedCamera}
                  style={true}
                />
              </div>
            )}

            {/* Alert Notifications */}
            <div className="d-flex flex-column align-items-center me-5">
              <p className="f3 mb-1 primary">Alert Notifications</p>

              {!groupForm.alert ? (
                <ToggleOffIcon
                  sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                  onClick={() => {
                    if (!emailVerified) return;
                    setGroupForm((prev) => ({
                      ...prev,
                      alert: 1,
                    }));
                    setGroupErrors((prev) => ({
                      ...prev,
                      alert: "",
                      beep: "",
                    }));
                  }}
                />
              ) : (
                <ToggleOnIcon
                  sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                  onClick={() =>
                    setGroupForm((prev) => ({
                      ...prev,
                      alert: 0,
                    }))
                  }
                />
              )}

              {/* Reserve space for error */}
              <div style={{ minHeight: "20px" }}>
                {groupErrors.alert && (
                  <p className="text-danger small mb-0">{groupErrors.alert}</p>
                )}
              </div>
            </div>

            {/* Beep Sound */}
            <div className="d-flex flex-column align-items-center ms-5">
              <p className="f3 mb-1 primary">Beep Sound</p>

              {!groupForm.beep ? (
                <ToggleOffIcon
                  sx={{ fontSize: 60, color: "gray", cursor: "pointer" }}
                  onClick={() => {
                    if (!emailVerified) return;
                    setGroupForm((prev) => ({
                      ...prev,
                      beep: 1,
                      alert: 1,
                    }));
                  }}
                />
              ) : (
                <ToggleOnIcon
                  sx={{ fontSize: 60, color: "green", cursor: "pointer" }}
                  onClick={() =>
                    setGroupForm((prev) => ({
                      ...prev,
                      beep: 0,
                    }))
                  }
                />
              )}

              {/* Reserve space for error */}
              <div style={{ minHeight: "20px" }}>
                {groupErrors.beep && (
                  <p className="text-danger small mb-0">{groupErrors.beep}</p>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {/* <hr className="border-t-2 border-gray-400 my-5" /> */}

      {/* {type != "view" && (
        <div className="d-flex flex-wrap gap-5">
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Name<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="name"
              value={formData.sitename}
              // onChange={handleChange}
              disabled
              type="text"
              placeholder="Site Name"
            />
            {errors.name && <p className="err">{errors.name}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Code<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="code"
              value={formData.code}
              // onChange={handleChange}
              disabled
              type="text"
              placeholder="Site Code"
            />
            {errors.code && <p className="err">{errors.code}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Address<span className="text-danger">*</span>
            </p>
            <input
              className="input-box"
              name="address"
              value={formData.address}
              // onChange={handleChange}
              disabled
              type="text"
              placeholder="Site Address"
            />
            {errors.address && <p className="err">{errors.address}</p>}
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary d-flex">
              Site Location<span className="text-danger">*</span>
            </p>
            <select
              name="location"
              value={formData?.sitelocation}
              className="input-box"
              type="text"
              disabled
            >
              <option>Select Location</option>
              {locList?.map((item) => {
                return (
                  <option value={item?.id} key={item?.id}>
                    {item?.name}
                  </option>
                );
              })}
            </select>
            {errors.location && <p className="err">{errors.location}</p>}
          </div>
        </div>
      )} */}

      {type == "view" && (
        <div className="d-flex flex-wrap gap-5">
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Name
            </p>
            <input
              className="input-box"
              name="name"
              value={data.siteName}
              readOnly
              type="text"
              placeholder="Site Name"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Address
            </p>
            <input
              className="input-box"
              name="address"
              value={data.siteAddress}
              readOnly
              type="text"
              placeholder="Site Address"
            />
          </div>
          <div className="col-md-5">
            <p className="f3 fs-sm-9 fs-md-11 fs-lg-13 fs-xl-15 fs-xxl-17 mb-1 primary">
              Site Location
            </p>
            <input
              className="input-box"
              name="location"
              value={data.siteLocation}
              readOnly
              type="text"
              placeholder="Site Location"
            />
          </div>
        </div>
      )}

      {/* Site */}

      {siteList.map((site) => (
        <div
          key={site.id}
          className="row align-items-center "
          style={{ fontSize: "14px" }}
        >
          {/* Admin Name */}
          <div className="col-md-2 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminName}
                onChange={(e) => handleSiteChange("adminName", e.target.value)}
              />
            ) : (
              <p className="mb-0">{site.adminName}</p>
            )}
          </div>

          {/* Admin Email */}
          <div className="col-md-3 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminEmail}
                disabled
              />
            ) : (
              <p className="mb-0">{site.adminEmail}</p>
            )}
          </div>

          {/* Admin Mobile */}
          <div className="col-md-2 d-flex align-items-center">
            {site.editing ? (
              <input
                className="input-box w-100"
                value={site.adminMobile}
                onChange={(e) =>
                  handleSiteChange("adminMobile", e.target.value)
                }
              />
            ) : (
              <p className="mb-0">{site.adminMobile}</p>
            )}
          </div>

          {/* this design is from chat gpt so careful */}
          {/* Admin Image */}
          <div className="col-md-1 d-flex justify-content-center">
            {site.editing ? (
              <div className="position-relative">
                <input
                  type="file"
                  accept="image/*"
                  id={`file-upload-${site.id}`}
                  style={{ display: "none" }}
                  onChange={(e) => handleSiteChange("adminImage", e)}
                />
                <label
                  htmlFor={`file-upload-${site.id}`}
                  className="d-flex align-items-center justify-content-center rounded-circle border"
                  style={{
                    width: "50px",
                    height: "50px",
                    cursor: "pointer",
                    background: "#f8f9fa",
                  }}
                >
                  <img
                    src={
                      site.adminImage
                        ? URL.createObjectURL(site.adminImage)
                        : user
                    }
                    alt="preview"
                    className="rounded-circle"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                  <span
                    className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle"
                    style={{
                      width: "16px",
                      height: "16px",
                      fontSize: "10px",
                      lineHeight: "16px",
                      textAlign: "center",
                    }}
                  >
                    +
                  </span>
                </label>
              </div>
            ) : (
              <img
                src={
                  site.adminImage ? URL.createObjectURL(site.adminImage) : user
                }
                alt=""
                className="rounded-circle"
                style={{ width: "50px", height: "50px", objectFit: "cover" }}
              />
            )}
          </div>

          {/* Active/De-active Button */}
          <div className="col-md-1">
            <button
              onClick={() => setPopup("active")}
              className={`${
                site.active ? "active-btn" : "deactive-btn"
              } w-100 border-0 py-1`}
            >
              {site.active ? "Active" : "De-active"}
            </button>
          </div>

          {/* Edit Button */}
          <div className="col-md-1 text-center">
            {site.editing ? (
              <button
                className="small-btn d-flex align-items-center justify-content-center mx-auto"
                onClick={() => handleEdit(site.id)}
              >
                <CheckCircleIcon fontSize="small" />
              </button>
            ) : (
              <button
                className="cust-btn mx-auto"
                onClick={() => handleEdit(site.id)}
              >
                <img src={edit_icon} alt="" className="edit-btn" />
              </button>
            )}
          </div>

          {/* Delete Button */}
          <div className="col-md-1 text-center">
            <button onClick={() => setPopup(true)} className="cust-btn mx-auto">
              <img src={delete_icon} alt="" className="edit-btn" />
            </button>
          </div>
        </div>
      ))}

      <hr className="border-t-2 border-gray-400 my-5" />

      {type == "view" && <CompanyGroupView groupUsers={groupUsers} />}
      {/* Render list */}

      {groupUsers?.length == 0 ? (
        <div className="text-center mt-5 p-5 border rounded bg-light">
          <p className="mb-0 f3 text-muted">
            No group users found for this site.
          </p>
        </div>
      ) : (
        <CompanySitesAdd
          groupUsers={groupUsers}
          setGroupPopup={setGroupPopup}
          type={"add"}
          deleteGroupUser={deleteGroupUser}
          handleGroupEdit={handleGroupEdit}
          groupUserStatus={groupUserStatus}
        />
      )}

      {/* <div className="d-flex ac-jb mt-5">
        <button
          onClick={handleSubmit}
          className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
        >
          Submit
        </button>
      </div> */}
    </div>
  );
};

export default SiteUser;
